module.exports = __webpack_public_path__ + "static/media/success.8907dee0.svg";